import { render, staticRenderFns } from "./TeacherPracticeVeds.vue?vue&type=template&id=09dfb373&scoped=true&"
import script from "./TeacherPracticeVeds.vue?vue&type=script&lang=js&"
export * from "./TeacherPracticeVeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfb373",
  null
  
)

export default component.exports